<template>
<v-card class='mb-5 grey lighten-4 elevation-10'>
  <v-overlay v-if='loading' absolute >
    <v-progress-circular color='amber' indeterminate size='75' width='2' />
  </v-overlay>
  <template v-if='withUploader' >
    <img
      v-if='uploaderUrl'
      @click='logoDialog=true'
      :class='{"rounded-circle": roundLogo}'
      style='z-index:3;position:absolute;max-height:140px;top:100px;left:25px;'
      :src='uploaderUrl' />
    <div v-else
      @click='logoDialog=true'
      class='rounded-circle teal white--text text-center pt-8'
      style='z-index:3;position:absolute;top:100px;left:25px;width:120px;height:120px;' >
      <!-- <v-icon dark x-large >mdi-account-circle-outline</v-icon><br/> -->
      <span class='subtitle-1' v-text='uploaderAttrs.title' />
      <br/>
      <span class='caption' >Click to upload</span>
    </div>
  </template>

  <v-img @click='showdialog=true' :aspect-ratio="16/9" height=200 v-if='value' :src='imgUrl' >
    <v-card-title >
      <v-btn
        v-if='withUploader'
        @click.stop='logoDialog=true' > Change logo</v-btn>
      <v-btn class='ml-3' >Change image</v-btn>
      <template v-if='hint' >
        <v-spacer></v-spacer>
        <help-popover color='white' >{{hint}}</help-popover>
      </template>
    </v-card-title>
  </v-img>
  <v-card-title v-else
    @click="showdialog=true"
    style='height:200px;' class='subheading' >
    <v-btn absolute right  @click='showdialog=true' >Choose one</v-btn>
    <div>No cover image</div>
    <small class='hidden-xs-only ml-2' style='max-width:80%;'>
      We'll use this image on your website and in general as a cover photo
    </small>
  </v-card-title>
  <v-divider />
  <!-- <v-card-text>URL: {{uploaderAttrs}}</v-card-text> -->
  <v-dialog fullscreen v-model='showdialog' >
    <v-card flat>
      <v-toolbar dense flat >
        <v-toolbar-title>Choose a background picture</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click='showdialog=false' icon ><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <image-search
          v-model='imgUrl'
          title='Search for an image'
          @close='showdialog=false' ></image-search>
      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-if='withUploader' width='300' v-model='logoDialog' >
    <uploader class='mt-4'
      @uploadsuccess='uploadSuccess'
      v-bind='uploaderAttrs' >
    </uploader>
  </v-dialog>
  <v-card-text v-if='label'
    style='text-align: right;'
    class='py-2 text-right' v-text='label' >
  </v-card-text>
  <v-alert v-if='errorMessages && errorMessages.length > 0' type='error' :value='true' class='pt-0 pb-1' >
    <ul>
      <li v-for='err in errorMessages' :key='err' v-text='err' ></li>
    </ul>
  </v-alert>
</v-card>
</template>

<script>
import HelpPopover from '@/components/ui/HelpPopover'
import ImageSearch from '@/components/ui/ImageSearch'
import Uploader from '@/components/ui/Uploader'

export default {
  name: 'BackgroundSelector',
  components: {HelpPopover, ImageSearch, Uploader},
  props: {
    value: { required: true, default: '' },
    hint: { type: String, required: false },
    label: { type: String, required: false, default: 'Choose a picture' },
    withUploader: { type: Boolean, default: false },
    roundLogo: { type: Boolean, default: false },
    errorMessages: { type: Array, default: () => { return [] } },
    uploaderAttrs: {
      type: Object,
      default: () => {
        return {
          title: 'Logo'
        }
      }
    }
  },
  data () {
    return {
      showdialog: false,
      logoDialog: false,
      hover: false,
      imgUrl: null,
      logoUrl: null,
      loading: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.imgUrl = this.value
      }
    },
    imgUrl () {
      this.$emit('input', this.imgUrl)
    },
    uploaderUrl () {
      if (this.uploaderUrl) {
        this.logoUrl = this.uploaderUrl
      }
      return null
    }
  },
  methods: {
    uploadSuccess (result) {
      this.logoUrl = result.data[this.uploaderAttrs.filename] + '?r' + Math.random().toString()
      this.$emit('update', this.uploaderAttrs)
      this.$emit('uploadSuccess', result)
      this.$emit('logourl', this.logoUrl)
      let vm = this
      setTimeout(() => {
        vm.logoDialog = false
      }, 500)
    }
  },
  computed: {
    uploaderUrl () {
      if (this.logoUrl) { return this.logoUrl }
      if (this.uploaderAttrs && this.uploaderAttrs.url) {
        return this.uploaderAttrs.url
      }
      return null
    }
  }
}
</script>

<style>

</style>
